import CustomChip from "../../components/shared/CustomChip";
import SelectThemeColor from "../../components/shared/SelectThemeColor";
import { useSelector } from "react-redux";
import { accessControlStatus, getAccessControlFieldValue, getBookingAccessControlState } from "./accessControlStatus";

const BookingAccessControlRender = (params) => {

  const storeUser = useSelector((store) => store.user);

  const getTextColor = (status) => {
    switch (status) {
      case accessControlStatus.allowed:
        return SelectThemeColor.availability.color.qualified;
      case accessControlStatus.restricted:
      case accessControlStatus.trainingRequired:
        return SelectThemeColor.availability.color.not_qualified;
      default:
        return SelectThemeColor.availability.color.unknown;
    }
  };

  const getBGColor = (status) => {
    switch (status) {
      case accessControlStatus.allowed:
        return SelectThemeColor.availability.background.available;
      case accessControlStatus.restricted:
      case accessControlStatus.trainingRequired:
        return SelectThemeColor.availability.background.booking;
      default:
        return SelectThemeColor.availability.background.unknown;
    }
  };

  const { status, cidmGroupName } = getBookingAccessControlState(params?.data, storeUser);

  const handleClick = (event) => {
    event.stopPropagation();

    if (status === accessControlStatus.trainingRequired && cidmGroupName) {
      const cidmGroupCidmUrl = getAccessControlFieldValue(params?.data, "cidm_group_cidm_url");
      const cidmGroupMoreInfoUrl = getAccessControlFieldValue(params?.data, "cidm_group_more_info_url");

      const openCidmDialogEvent = new CustomEvent('openCidmDialog', {
        detail: {
          name: cidmGroupName || '',
          url: cidmGroupCidmUrl || '',
          info: cidmGroupMoreInfoUrl || '',
        }
      });
      document.dispatchEvent(openCidmDialogEvent);
    }
  };

  return <CustomChip
    text={status}
    color={getTextColor(status)}
    bgColor={getBGColor(status)}
    bold
    style={{ cursor: status === accessControlStatus.trainingRequired ? 'pointer' : 'default' }}
    onClick={handleClick}
  />;
};

export default BookingAccessControlRender;
